import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { FilterConfig, FilterState } from '../models/filter.model';

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  private filtersSubject = new BehaviorSubject<FilterState>({});
  private filterConfigSubject = new BehaviorSubject<FilterConfig[]>([]);

  public filters$ = this.filtersSubject.asObservable();
  public filterConfig$ = this.filterConfigSubject.asObservable();

  private lastPath = '';

  constructor(private router: Router) {
    // Reseta filtros apenas quando o path da rota muda (não quando apenas query params mudam)
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const currentPath = event.urlAfterRedirects.split('?')[0];
        if (this.lastPath && currentPath !== this.lastPath) {
          this.clearFilters();
        }
        this.lastPath = currentPath;
      });
  }

  /**
   * Configura os filtros disponíveis para um componente
   */
  setFilterConfig(config: FilterConfig[]): void {
    this.filterConfigSubject.next(config);
  }

  /**
   * Aplica um filtro específico
   */
  setFilter(key: string, value: any): void {
    const currentFilters = this.filtersSubject.value;
    const newFilters = { ...currentFilters, [key]: value };
    this.filtersSubject.next(newFilters);
  }

  /**
   * Remove um filtro específico
   */
  removeFilter(key: string): void {
    const currentFilters = this.filtersSubject.value;
    const newFilters = { ...currentFilters };
    delete newFilters[key];
    this.filtersSubject.next(newFilters);
  }

  /**
   * Limpa todos os filtros
   */
  clearFilters(): void {
    this.filtersSubject.next({});
  }

  /**
   * Obtém o estado atual dos filtros
   */
  getCurrentFilters(): FilterState {
    return this.filtersSubject.value;
  }

  /**
   * Obtém a configuração de filtros atual
   */
  getFilterConfig(): FilterConfig[] {
    return this.filterConfigSubject.value;
  }
}
